const UNAVAILABLE = '-';

/**
 * A live window's `window_start` / `window_end` are integer seconds into the
 * recording, not timestamps. Formatting them as datetimes rendered every row
 * as blank or 1970.
 */
export const formatElapsedSeconds = (seconds: number | null | undefined): string => {
  if (seconds == null) return UNAVAILABLE;
  const total = Math.floor(Number(seconds));
  if (!Number.isFinite(total) || total < 0) return UNAVAILABLE;

  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const remainder = total % 60;
  const paddedSeconds = String(remainder).padStart(2, '0');

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${paddedSeconds}`;
  }
  return `${String(minutes).padStart(2, '0')}:${paddedSeconds}`;
};

export const formatWindowRange = (
  windowStart: number | null | undefined,
  windowEnd: number | null | undefined,
): string => `${formatElapsedSeconds(windowStart)} – ${formatElapsedSeconds(windowEnd)}`;
